import React from 'react';
import PropTypes from 'prop-types';
import DisplayPanel from './DisplayPanel';
import WalletButton from './WalletButton';
import biglogo from '../assets/SendUSDC.png';
import biglogo2 from '../assets/WizardEmoji2.png';

const Header = ({ userAddress, ensName, userBalance, usdcBalance, provider, loadWeb3Modal }) => {
	return (
		<div
			style={{
				backgroundColor: '#282c34',
				minHeight: '80px',
				display: 'flex',
				flexDirection: 'row',
				alignItems: 'center',
				justifyContent: 'flex-end',
				color: 'white'
			}}
		>
			{!userAddress && (
				<a href="/">
					<img
						style={{
							height: '160px',
							left: '0px',
							position: 'absolute',
							marginTop: '-30px',
							marginLeft: '-30px'
						}}
						src={biglogo2}
						alt="Spellcaster-logo"
					/>
				</a>
			)}
			{userAddress && (
				<img
					style={{
						height: '160px',
						left: '0px',
						position: 'absolute',
						margin: '16px 0px 0px 0px'
					}}
					src={biglogo}
					alt="SendUSDC-logo"
				/>
			)}

			{userAddress && (
				<DisplayPanel
					ensName={ensName}
					userAddress={userAddress}
					userBalance={userBalance}
					usdcBalance={usdcBalance}
				/>
			)}
			<WalletButton provider={provider} loadWeb3Modal={loadWeb3Modal} />
		</div>
	);
};

Header.propTypes = {
	userAddress: PropTypes.string,
	ensName: PropTypes.string,
	userBalance: PropTypes.string,
	usdcBalance: PropTypes.string,
	provider: PropTypes.object,
	loadWeb3Modal: PropTypes.func
};

export default Header;
